import axios from 'axios';
import { Baseurl } from './Baseurl';



 const fetchData = () => {
  return axios.get(`${Baseurl}/users`);
};
export default fetchData;